// extracted by mini-css-extract-plugin
module.exports = {"centralizeItems":"dashGlobal_centralizeItems__1XVMz","iconEl":"dashGlobal_iconEl__9dPnl"};